import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import API from "../config/api.js";

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !user) {
      const currentUrl = window.location.href;
      window.location.href = `${API.baseUrl}/sign-in?redirect=${encodeURIComponent(currentUrl)}`;
    }
  }, [loading, user, location]);

  if (loading) {
    return null;
  }

  if (!user) {
    return null;
  }

  return children;
}
